import * as React from 'react';
import formatters, { formatter } from '../formatters';
import {
  debugCountAsPercentage,
  debugMigrationForward,
  debugRevenueAsPercentage,
} from './common';

export function debugCheerleadersCountAsPercentage(benchmark, value, weighted) {
  return debugCountAsPercentage(benchmark, value, weighted);
}

export function debugCheerleadersRevenueAsPercentage(
  benchmark,
  value,
  weighted
) {
  return debugRevenueAsPercentage(benchmark, value, weighted);
}

export function debugCheerleadersMigrationForward(benchmark, value, weighted) {
  return debugMigrationForward(benchmark, value, weighted);
}

export function debugCheerleadersIndValue(
  benchmark,
  value,
  weighted,
  casualIndValue?,
  cheerleaderIndValue?
) {
  return (
    <div>
      <p>Ind Value</p>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Benchmark</td>
            <td>{benchmark}:1 of casual value</td>
          </tr>
          <tr>
            <td>Casual Ind Value</td>
            <td>{formatters.currency.format(casualIndValue)}</td>
          </tr>
          <tr>
            <td>Cheerleader Ind Value</td>
            <td>{cheerleaderIndValue}</td>
          </tr>
          <tr>
            <td>Value</td>
            <td>{formatters.count.format(value)}:1</td>
          </tr>
          <tr>
            <td>Score</td>
            <td>{weighted}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
